// Password strength scoring, shared by the PasswordStrength meter and the
// signup schema so both judge strength by the exact same rules.

/**
 * Score a password 0–4 by how many criteria it satisfies:
 * length ≥ 8, has an uppercase letter, has a digit, has a non-alphanumeric char.
 */
export const scorePassword = (password: string): number => {
  let s = 0;
  if (!password) return 0;
  if (password.length >= 8) s++;
  if (/[A-Z]/.test(password)) s++;
  if (/[0-9]/.test(password)) s++;
  if (/[^A-Za-z0-9]/.test(password)) s++;
  return s; // 0..4
};
